module.exports = __webpack_public_path__ + "img/confirmed.ec3af10d.svg";